import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import PanelDonate from "../components/PanelDonate.js";
import { extractPaymentData, getQueryStringData, translation as t } from "../../inc/helpers.js";
import paypal from "../../inc/paypal.js";
import paypalSubscription from "../../inc/paypal-subscription.js";
import stripe from "../../inc/stripe.js";
import Swipers from "../components/Swipers.js";

export default class PageArchiveProjects extends PageCommon {
    constructor() {
        super();
        this._data = null;
        this._panelDebouncer = null;
        this._currentPayment = null;
    }

    init($data) {
        super.init($data);
        this._data = $data;
        this.showPreloader(false);
        Pqp.trace("PageArchiveProjects - Hello world");

        this.initSwipers();
        
        // dispaccio un evento globale
        try {
            this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
        } catch (error) {
            console.log(error);
        }
    }          

    initSwipers() {

    }

    get isHomepage() {
        return false;
    }
}